<template>
  <v-main class="viewContainer pa-0">
    <!-- Pour modifier les sections ci-dessous, allez dans le dossier "./src/views/sections" -->
    <heroSection />
    <solutionSection />
    <whyUsSection />
    <videoSection />
    <digitToPhysicSection />
    <ourBeaconsSection />
    <maBaliseSection />
  </v-main>
</template>

<script>
import heroSection from "./sections/home_hero.vue";
import solutionSection from "./sections/home_solution.vue";
import whyUsSection from "./sections/home_whyUs.vue";
import videoSection from "./sections/home_video.vue";
import digitToPhysicSection from "./sections/home_digitalToPhysical.vue";
import ourBeaconsSection from "./sections/home_ourBeacons.vue";
import maBaliseSection from "./sections/home_maBalise.vue";

export default {
  name: "my-cool-component",

  components: {
    heroSection,
    solutionSection,
    whyUsSection,
    videoSection,
    digitToPhysicSection,
    ourBeaconsSection,
    maBaliseSection,
  },

  created() {},

  mounted() {
    document.title = this.$t("home_page_title");
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.pulsate {
  animation: pulse 3s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

// Espacement global entre boutons
.ga-4 {
  gap: 16px;
}

.card-product {
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
  }
}
</style>
